// extracted by mini-css-extract-plugin
export default {"content":"klPxeHpbR3E_h033uwEE","text":"k07bFwZAD7k8HKN3IPkG","small":"q5BlN51N7ADH6bjjjN3_"};